import View3D from "components/Product/View3D"
import PropTypes from "prop-types"
import React from "react"
import {Component} from "react"
import shop from "shop/shop"


import "style/ProductImages.scss"
import Slider from "components/Slider/Slider"
import ImageWithFallback from "components/ImageWithFallback"

export default class ProductImages extends Component {

	render() {
		const {images, image, onClick, product} = this.props
		if ( images.length === 0 ) {
			return <div className="ProductImages">
				<div className="">
					<div><ImageWithFallback fallback={"/image/placeholder.png"} src={image} /></div>
				</div>
			</div>
		}
		return (
			<div className="ProductImages">
				<div className=" ">
					<Slider>
						{images.map( ( {img_src_large} ) => (<ImageWithFallback
							fallback={"/image/placeholder.png"}
							key={img_src_large}
							alt={`${product.title}`}
							title={`${product.title}`}
							onClick={() => {
								onClick( img_src_large )
							}}
							src={img_src_large} />) )}
					</Slider>
				</div>


				<div className="product-images pt2 ">

					{images.map( ( {img_src_large, img_src_medium} ) => <div key={img_src_medium} className="pa2">
						<ImageWithFallback
							fallback={"/image/placeholder.png"}
							className="img-thumbnail "
							alt={`${product.title}`}
							title={`${product.title}`}
							onClick={() => {
								onClick( img_src_large )
							}}
							src={img_src_medium} />
					</div> )}


					{shop.config.plugin["view3D"] && <View3D id={product.map_id} title={product.desc.short_des} />}
				</div>
			</div>
		)
	}
}

ProductImages.propTypes = {
	images : PropTypes.any,
	image  : PropTypes.any,
	onClick: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/components/Product/ProductImages.js